
import { defineComponent, PropType } from 'vue'

import {
  Analyzer,
  AnalyzerConnection,
  IssueOccurrenceFrequency,
  Maybe,
  Run,
  RunConnection
} from '~/types/types'
import { resolveNodes } from '~/utils/array'
import { shortenLargeNumber } from '~/utils/string'

export default defineComponent({
  name: 'MetadataView',
  props: {
    ready: {
      type: Boolean,
      default: false
    },
    issuesPrevented: {
      type: [String, Number] as PropType<string | number>,
      default: ''
    },
    issueOccurrenceDistributionByIssueType: {
      type: Array as PropType<Array<IssueOccurrenceFrequency>>,
      default: () => []
    },
    defaultBranchName: {
      type: String as PropType<Maybe<string>>,
      default: ''
    },
    availableAnalyzers: {
      type: Object as PropType<Maybe<AnalyzerConnection>>,
      default: () => null
    },
    latestAnalysisRun: {
      type: Object as PropType<Maybe<Run>>,
      default: () => null
    },
    runs: {
      type: Object as PropType<Maybe<RunConnection>>,
      default: () => null
    },
    showKnowledgeSync: {
      type: Boolean,
      default: false
    },
    lastKnowledgeSync: {
      type: String,
      default: 'Never'
    }
  },
  computed: {
    analyzers(): Array<Analyzer> {
      return resolveNodes(this.availableAnalyzers)
    },
    othersList() {
      const initialListCount = 4
      return this.analyzers.slice(initialListCount)
    },
    initialList() {
      const initialListCount = 4
      return this.analyzers.slice(0, initialListCount)
    },
    totalIssueCount(): string | number {
      // Truthy-guard: `issueOccurrenceDistributionByIssueType` can be null briefly on nav.
      const distributionEntries = this.issueOccurrenceDistributionByIssueType?.find(
        ({ key }) => key === 'all'
      )
      return shortenLargeNumber(distributionEntries?.count as number) || 0
    }
  }
})
